<template>
  <label label="forKey" class="py-0 !px-0 border-none !m-0 cursor-pointer">
    <input
      ref="inputRef"
      :type="type"
      v-model="modelValue"
      name="forKey"
      :disabled="disabled"
      class="!appearance-none m-0 cursor-pointer"
      v-bind="$attrs"
      format="dd/MM/yyyy"
      @click="openPicker"
      @focus="openPicker"
    />
  </label>
</template>

<script lang="ts" setup>
import { ref, useModel } from "vue";

const props = defineProps<{
  modelValue: string;
  disabled?: boolean;
  type?: string;
}>();
const modelValue = useModel(props, "modelValue");
const type = props.type ?? "date";

const emit = defineEmits<{
  (event: "update:modelValue", value: string): void;
}>();

const inputRef = ref<HTMLInputElement>();

const openPicker = () => {
  inputRef.value?.showPicker?.();
};
</script>
